import React, { Component } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Button, Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";
import { toast } from "react-toastify";

class clearanceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      RequesterId: "",
      RequesterName: "",
      RequesterSectionName: "",
      canStafNamePopover: "flex",
      showFirstStaffPopup: "",
      RequesterDisplayName: "",
      RequesterSection: "",
      RequesterDepartment: "",
      RequesterDivision: "",
      RequesterDesignation: "",
      popupEmployeeId: "",
      getEmployeeFirstShow: false,
      popupEmployeeName: "",
      popupSection: 0,
      section: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
      reportList: [],
      reportData: "",
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "eDoc Type",
    });
    this.SectionListData();
  }

  showFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: true });
  };

  hideFirstStaffPopup = () => {
    this.setState({
      popupEmployeeId: "",
      getEmployeeFirstShow: false,
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  searchEmployee = () => {
    try {
      this.setState({ StaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.popupEmployeeId,
        name: this.state.popupEmployeeName,
        section: this.state.section.value,
        employeeType: "All",
      };

      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ StaffDetailslistArray: data.resultObject });
            this.setState({ StaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      section: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  SectionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/SectionDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              sectionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  getStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      RequesterId: id,
      RequesterName: name,
      RequesterSection: section,
      RequesterSectionName: sectionName,
      RequesterDepartment: department,
      RequesterDivision: division,
      RequesterDesignation: designation,
      canStafNamePopover: "flex",
      getEmployeeFirstShow: false,
      RequesterDisplayName: id + " - " + name,
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  print = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      window.print();
    }, 1500);
  };

  generate = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Report/EmployeeClearanceReport?StaffId=${parseInt(
            this.state.RequesterId
          )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (
              !data?.resultObject?.approverDetails.length &&
              !data?.resultObject.employeeDetails
            ) {
              toast.info("Cannot Generate Report", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            } else {
              this.setState({
                reportList: data?.resultObject?.approverDetails,
                reportData: data?.resultObject.employeeDetails,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    let SectionTypeOptionList = [];
    if (this.state.sectionListArray?.length > 0) {
      this.state.sectionListArray?.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.code,
        };
        SectionTypeOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb className="no-print">
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Report By Staff (Clearance)</Breadcrumb.Item>
        </Breadcrumb>
        <Modal show={this.state.getEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="popupEmployeeId"
                      value={this.state.popupEmployeeId}
                      onChange={(e) =>
                        this.setState({
                          popupEmployeeId: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="popupEmployeeName"
                      value={this.state.popupEmployeeName}
                      onChange={(e) =>
                        this.setState({ popupEmployeeName: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={SectionTypeOptionList}
                      value={this.state.section}
                      onChange={(value) => this.setState({ section: value })}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={this.searchEmployeeClear}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray?.map((staff) => (
                      <tr
                        className="cursor-pointer"
                        onClick={() =>
                          this.getStaffDetails(
                            staff.employeeId,
                            staff.name,
                            staff.section,
                            staff.sectionName,
                            staff.department,
                            staff.division,
                            staff.designation
                          )
                        }>
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.employeeId} </td>
                        <td> {staff.name} </td>
                        <td> ({staff.account}) </td>
                        <td> {staff.email} </td>
                        <td> {staff.section} </td>
                        <td> {staff.sectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray?.length <= 0 &&
                    this.state.StaffDetailslistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.hideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="content-area">
          <section className="view-taskpending-section no-print">
            <div className="form-group mb-4">
              <h5>Employee Clearance Report</h5>
            </div>
          </section>

          <section className="view-taskpending-section">
            <div className="form-group row">
              <label
                for=""
                className="col-sm-2 col-form-label text-muted no-print">
                <span style={{ display: "flex" }}>
                  Staff No / Name(Approver)
                  <p style={{ color: "red", marginLeft: 5 }}>*</p>{" "}
                </span>
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2 no-print">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    placeholder=""
                    readOnly={true}
                    value={this.state.RequesterDisplayName}
                    onClick={this.showFirstStaffPopup}
                  />
                  <div
                    className="input-group-prepend"
                    onClick={this.showFirstStaffPopup}>
                    <div className="input-group-text">
                      <i className="fa fa-search text-muted"> </i>
                    </div>
                  </div>
                  <div
                    className="input-group-prepend ml-3"
                    style={{ display: this.state.canStafNamePopover }}>
                    <button
                      id="PopoverLegacy"
                      className="input-group-text"
                      type="button"
                      data-toggle="popover"
                      data-placement="bottom">
                      <i className="fa fa-info text-muted"> </i>
                    </button>
                  </div>
                  <Button
                    onClick={this.generate}
                    className="child-comments ml-2 mr-1"
                    color="primary">
                    Generate
                  </Button>
                  <Button onClick={this.print} className="btn btn-secondary">
                    Print
                  </Button>
                </div>

                <UncontrolledPopover
                  trigger="legacy"
                  placement="bottom"
                  target="PopoverLegacy">
                  <PopoverHeader></PopoverHeader>
                  <PopoverBody>
                    <div class="pop">
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Section</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterSection}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Department</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDepartment}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Division</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDivision}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Designation</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDesignation}
                        </div>
                      </div>
                    </div>
                  </PopoverBody>
                </UncontrolledPopover>
              </div>
            </div>
          </section>
          <div className="report-area">
            <section className="view-taskpending-section">
              <div className="form-group row mt-4 mb-5">
                <div className="col-sm-2">
                  <img
                    height="50px"
                    width="100px"
                    className="action-right-space mouse-pointer"
                    src={
                      process.env.REACT_APP_ENV +
                      "/assets/images/logo/GGP-logo.png"
                    }
                    alt="Close"
                    data-tip="Delegate"
                  />
                </div>
                <div className="col-sm-10">
                  <h5 className="text-center">
                    MALAYSIA MARINE AND HEAVY ENGINEERING
                  </h5>
                  <br />
                  <h6 className="text-center"> Employee Clearance</h6>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Name
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>{this.state.reportData.staffName}</span>
                  </div>
                </div>
                <div className="col-sm-2"></div>
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Staff ID
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>{this.state.reportData.staffId}</span>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Divison
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>{this.state.reportData.division}</span>
                  </div>
                </div>
                <div className="col-sm-2"></div>
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Department/division
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>{this.state.reportData.department}</span>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-3 ">
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Phone Number
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>{this.state.reportData.phoneNumber}</span>
                  </div>
                </div>
                <div className="col-sm-2"></div>
                <label
                  for=""
                  className="col-sm-2 mytask-reference-text col-form-label">
                  Last Day of Service
                </label>
                <div className="col-sm-2">
                  <div className="col-form-label">
                    <span>
                      {this.state?.reportData?.empLastDayService?.split("T")[0]}
                    </span>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <div className="customized-table">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="thead-lightBlue">
                      <tr>
                        <th scope="col">Section</th>
                        <th scope="col">EmployeeID</th>
                        <th scope="col">Verified By</th>
                        <th scope="col">Check List </th>
                        <th scope="col">Comments</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.reportList?.map((dt) => (
                        <tr>
                          <td>{dt.section}</td>
                          <td>{dt.approverId}</td>
                          <td>{dt.approverName}</td>
                          <td>
                            {dt.checkList?.map((dt) => (
                              <ul>
                                {dt.item} - {dt.value} <br />
                              </ul>
                            ))}
                          </td>
                          <td>{dt.comments}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};
export default connect(mapStateToProps)(clearanceReport);
